import zoom from '@gaming/srvg-common-zoom';
import flost from '@gaming/srvg-common-flost';
import debug from '@gaming/srvg-common-debug';
import eventExchange from '@gaming/srvg-common-event-exchange';
import featureInstances from '@gaming/srvg-common-feature-instances';
import { Matomo } from '@gaming/srvg-matomo';
import { init } from '../../../../node_modules/@bremen_webteam/srvg-oddsconversion/lib/oddsconversion.lib'
import { openStats } from './utils/openStats';
import { postMessageHandler } from './utils/postMessageHandler';


declare var app:any;

export default function() {
    const srvg = (window as any).srvg || {};
    const piwikUrl = srvg.piwik.host.indexOf('//') !== -1 ? srvg.piwik.host : ("https:" === document.location.protocol ? "https://"+srvg.piwik.host : "http://"+srvg.piwik.host);

    // Init Matomo Piwik tracking
    Matomo.init({
        url: piwikUrl,
        siteId: srvg.piwik.trackingId
    });
    srvg.Matomo = srvg.Matomo || Matomo;

    // Init the commons
    srvg.debug = Object.assign({}, debug, srvg.debug);
    srvg.featuresInstances = featureInstances;
    srvg.featuresInstances.setDebug(srvg.debug);
    zoom.init();
    if(srvg.flostEnabled) {
        srvg.flost = srvg.flost ? Object.assign(srvg.flost, flost) : flost;
    }
    srvg.eventExchange = eventExchange;
    eventExchange.setDebugView(srvg.debugView);
    srvg.oddsconversion = init();

    if(!(window as any).openVfecStats) {
        (window as any).openVfecStats = openStats;
    }

    if(!(window as any).openVfStats) {
        (window as any).openVfStats = openStats;
    }

    /**
     * Sets the matchday/chunk of the current season in the matchday/chunk picker.
     */
    function setVfecSelectedMatchday(timestamp:number){
        if(timestamp > 0){
            srvg.customerIntegration.setSelectedMatchdayByTimestamp(timestamp);
        }
    }
 
    if(!(window as any).setVfecSelectedMatchday) {
        (window as any).setVfecSelectedMatchday = setVfecSelectedMatchday;
    }

    /**
     * Sets the matchday/chunk of the current season in the matchday/chunk picker. (VFLM)
     */
    function setSelectedMatchday(matchday:number, nextSeason: boolean){
        if (srvg.product.mode === "VFWC" ||  srvg.product.mode === "VFCC"){
            setVfecSelectedMatchday(matchday);
            return;
        }

        const currentMatchday = this.app.timeline.currentChunkModel.chunk.matches[0].matchset.nr;
        const difference = matchday - currentMatchday;
        let offset = difference.toString();
        if(difference>5 ){
            offset = ">5";
        }
        else if (difference < -5){
            offset = "< -5"
        }

        if(matchday > 0 && matchday < 31){
            //console.log("setSelectedMatchday: " + matchday);
            if(nextSeason) {
                //console.log("setSelectedMatchday(next): " + matchday);
                srvg.customerIntegration.setSelectedMatchday(matchday, nextSeason);
            }
            else {
                //console.log("setSelectedMatchday: " + matchday);
                srvg.customerIntegration.setSelectedMatchday(matchday);
            }
        }
    }

    if(!(window as any).setSelectedMatchday) {
        (window as any).setSelectedMatchday = setSelectedMatchday;
    }

    window.addEventListener("message", postMessageOnlineCIReceiveMessage, false);


// test :  postMessageOnlineCIReceiveMessage({data: '{"customerIntegration":{"action":"openCompetitorStats","data":{"competitor_id_1":276501, "competitor_id_2":276502}}}'})
    function postMessageOnlineCIReceiveMessage(event) {
        if(event.data !== "toolbar") {
            srvg.debug.console('info', 'event', event);
            var eventData = {customerIntegration: null};    // empty object doesn't work with typescript
            try{
                eventData = event.data;
            }catch(e){
                srvg.debug.console('error', "Error occurs while parsing JSON", event.data);
                return;
            }

            srvg.debug.console('info', 'eventData', eventData);
            if (typeof eventData.customerIntegration !== "undefined"){
                var action = eventData.customerIntegration.action;
                var data = eventData.customerIntegration.data;
                srvg.debug.console('info', 'event will be searched:', action);
                switch(action){
                    case 'openCompetitorStats':
                    case 'openVfStats':
                    case 'openVfecStats':
                        if (typeof data.competitor_id_1  !== "undefined" && typeof data.competitor_id_2  !== "undefined" ){
                            srvg.debug.console('info', 'openStats', data.competitor_id_1, data.competitor_id_2);
                            openStats(data.competitor_id_1, data.competitor_id_2, null);
                        }else{
                            console.error("openStats - parameter for competitor 1 and/or 2 is missing");
                        }
                        break;
                    case 'setSelectedMatchday':
                        srvg.customerIntegration.setSelectedMatchday(data.matchday, data.nextSeason)
                        break;
                    default:
                        break;
                }
            }
        }
    }

    if(!(window as any).postMessageOnlineCIReceiveMessage) {
        (window as any).postMessageOnlineCIReceiveMessage = postMessageOnlineCIReceiveMessage;
    }

    window.addEventListener("message", postMessageHandler, false);
}